<template>
  <div>
    <div class="voucher-porto">
      <p class="voucher-porto__hint">*{{ $t("vouchers.portoHint") }}</p>
    </div>


    <div class="voucher-list__bottom">
      <div class="voucher-list__choice">
        <div class="voucher-list__chosen" v-for="(item, i) in basket">
          <span>{{ item.title }}</span>
          <span>{{ item.quantity }}x {{ formatPrice(item.price, "long") }}</span>
        </div>

        <div class="voucher-list__chosen" v-if="shippingCosts">
          <span>{{ $t("vouchers.portoTitle") }}</span>
          <span>{{ formatPrice(shippingCosts, "long") }}</span>
        </div>

        <div class="voucher-list__summary" :class="{'voucher-list__summary--active': totalQuantity}">
          <h3 class="voucher-list__sum">{{ $t("vouchers.sum") }}</h3>
          <h3 class="">{{ formatPrice(total, "long") }}</h3>
        </div>
      </div>

      <div class="voucher-message" v-if="hasBigVoucher">
        <span>{{ $t("vouchers.bigVoucherMessage") }}</span>
      </div>
      <input
        :name="`shippingCost`"
        type="hidden"
        v-model.number="shippingCosts"
      />
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    basket() {
      return this.$root.$data.shared.vouchers.filter(v => v.quantity > 0)
    },

    hasBigVoucher() {
      return !!this.basket.find(item => item.title.includes('CHF 50'))
    },

    subTotal() {
      let total = this.basket.reduce((p, c) => {

        return p + Math.floor(c.price * 100) * c.quantity;

      }, 0);

      total = Math.floor(total) / 100

      // HACK: we set this value in this computed property to notify the most outer component without vuex
      this.$root.$data.shared.validBasket = total > 0

      return parseFloat(total)

    },

    total() {
      return (this.subTotal + this.shippingCosts)
    },

    totalQuantity() {
      let total = this.basket.reduce((p, c) => {

        return p + c.quantity;

      }, 0);

      return total
    },

    shippingCosts() {
      let portoData = this.$root.$data.shared.porto;

      let porto = portoData
        .sort((a, b) => {

          return a.amount - b.amount
        })
        .reduce((cost, porto) => {
          if (porto.amount <= this.totalQuantity) {
            return porto.cost
          }
          return cost
        }, 0)

      return parseFloat(porto)

    },
  },
  methods: {
    itemTotal(item) {
      return item.price * item.quantity;
    }
  }
};
</script>

<style></style>
